import { defineComponent as _defineComponent } from 'vue'
import { useUsuarioStore } from "@/store/usuarioStore";
import {
  computed,
  defineOptions,
  onMounted,
  reactive,
} from "vue";
import CustomSearch from "./CustomSearch.vue";

type AnyField = any;


export default /*#__PURE__*/_defineComponent({
  ...{ name: "custom-filter-button" },
  __name: 'CustomFilterButton',
  props: {
    fields: { type: Array, required: true },
    usePerfilDados: { type: Boolean, required: false },
    clearDependentFields: { type: Object, required: false },
    clearAllIndependent: { type: Boolean, required: false }
  },
  emits: ["data", "selected", "ufSelected", "canceled", "cleaned", "limpar"],
  setup(__props: any, { expose: __expose, emit }) {
  __expose();

const props = __props;







const usuarioStore = useUsuarioStore();

const state = reactive({
  show_drop_down_menu: false,
  clearedFields: new Set<string>(),
});

const processedFields = computed(() => {
  if (!props.usePerfilDados || !usuarioStore.perfilDados) {
    return props.fields;
  }

  const perfilDados = usuarioStore.perfilDados;
  return props.fields.map((field: any) => {
    if (field.name === "rede_ensino" && perfilDados.redeEnsino) {
      const perfilRedeEnsinoNum = Number(perfilDados.redeEnsino);
      const filteredOptions = field.options.filter(
        (opt: any) => Number(opt.value) === perfilRedeEnsinoNum
      );

      return {
        ...field,
        options: filteredOptions,
        value: state.clearedFields.has("rede_ensino")
          ? ""
          : filteredOptions.length === 1
          ? perfilRedeEnsinoNum
          : field.value,
      };
    }

    if (field.name === "uf" && perfilDados.uf) {
      const filteredOptions = field.options.filter(
        (opt: any) => opt.value === perfilDados.uf
      );

      return {
        ...field,
        options: filteredOptions,
        value: filteredOptions.length === 1 ? perfilDados.uf : field.value,
      };
    }

    if (field.name === "municipio_id" && perfilDados.municipioId) {
      const perfilMunicipioIdNum = Number(perfilDados.municipioId);
      const filteredOptions = field.options.filter(
        (opt: any) => Number(opt.value) === perfilMunicipioIdNum
      );

      return {
        ...field,
        options: filteredOptions,
        value:
          filteredOptions.length === 1 ? perfilMunicipioIdNum : field.value,
      };
    }

    if (field.name === "coordenadoria_id" && perfilDados.coordenadoriaId) {
      const perfilCoordenadoriaIdNum = Number(perfilDados.coordenadoriaId);
      const filteredOptions = field.options.filter(
        (opt: any) => Number(opt.value) === perfilCoordenadoriaIdNum
      );

      return {
        ...field,
        options: filteredOptions,
        value:
          filteredOptions.length === 1 ? perfilCoordenadoriaIdNum : field.value,
      };
    }

    if (
      field.name === "escola_id" &&
      perfilDados.escolasId &&
      perfilDados.escolasId.length > 0
    ) {
      const filteredOptions = field.options.filter((opt: any) =>
        perfilDados.escolasId.includes(Number(opt.value))
      );

      return {
        ...field,
        options: filteredOptions,
        value:
          filteredOptions.length === 1 ? filteredOptions[0].value : field.value,
      };
    }

    return field;
  });
});

onMounted(async () => {
  if (props.usePerfilDados && !usuarioStore.dadosCarregados) {
    await usuarioStore.carregarDadosUsuario();
  }

  const perfilRedeEnsino = usuarioStore.perfilDados?.redeEnsino;
  if (props.usePerfilDados && perfilRedeEnsino) {
    const perfilRedeEnsinoNum = Number(perfilRedeEnsino);
    const fieldRedeEnsino = props.fields.find(
      (f: any) => f.name === "rede_ensino"
    ) as { options?: any[]; value?: any } | undefined;

    if (fieldRedeEnsino?.options) {
      const filteredOptions = fieldRedeEnsino.options.filter(
        (opt: any) => Number(opt.value) === perfilRedeEnsinoNum
      );

      const valueToEmit =
        filteredOptions.length === 1
          ? perfilRedeEnsinoNum
          : fieldRedeEnsino.value;

      emit("selected", { name: "rede_ensino", value: valueToEmit });
    }
  }
});

function getFilledData(event: any[]) {
  if (!event.length) return;

  state.clearedFields.clear();

  const customSearch: Record<string, any> = {};
  for (const key of event) {
    if (key["value"]) {
      customSearch[key["name"]] = key["value"];
    }
  }
  emit("data", customSearch);
}

function getSelectedData(event: any) {
  emit("selected", event);
  emit("ufSelected", event);
}

function showDropDownMenu() {
  state.show_drop_down_menu = true;
}

function hideDropDownMenu() {
  state.show_drop_down_menu = false;
}

function getCanceled(event: any) {
  emit("canceled", event);
}

function getCleaned(event: any) {
  if (props.clearDependentFields) {
    Object.keys(props.clearDependentFields).forEach((fieldName) => {
      state.clearedFields.add(fieldName);
    });
  }

  emit("cleaned", event);
  emit("limpar");
}

const __returned__ = { props, emit, usuarioStore, state, processedFields, getFilledData, getSelectedData, showDropDownMenu, hideDropDownMenu, getCanceled, getCleaned, CustomSearch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})